import React from 'react';
import { toast } from 'react-toastify';
import { ToastMessage } from './ToastMessage';

export const toastError = (message?: string, title?: string) =>
    message && toast.error(<ToastMessage
        title={title}
        message={message}
        date={new Date()}
    />);

export const toastWarn = (message?: string, title?: string) =>
    message && toast.warn(<ToastMessage
        title={title}
        message={message}
        date={new Date()}
    />);

export const toastInfo = (message?: string, title?: string) =>
    message && toast.info(<ToastMessage
        title={title}
        message={message}
        date={new Date()}
    />);

export const toastSuccess = (message?: string, title?: string) =>
    message && toast.success(<ToastMessage
        title={title}
        message={message}
        date={new Date()}
    />);